import { FC } from 'react'

import { useAtomValue } from 'jotai'

import { AnalyticsCard } from '../../../components'
import { TotalViewsGraph } from './TotalViewsGraph'
import { GraphTimescaleDropdown } from './GraphTimescaleDropdown'
import { totalViewsCountAtom } from '../../../atoms'

export const TotalViewsCard: FC = () => {
  const totalViewsCount = useAtomValue(totalViewsCountAtom)

  return (
    <AnalyticsCard
      title="Total views"
      value={totalViewsCount.toLocaleString('en-US')}
      control={<GraphTimescaleDropdown />}
      data-testid="quoteAnalytics.totalViews"
    >
      <TotalViewsGraph />
    </AnalyticsCard>
  )
}
